import { Dimension, PlThemeColors, RuntimeAggOption } from "@gspwidget/util"
import { DataField } from "@gspwidget/widget-devkit"

const aggFirstDim2Field = (runtimeAgg: RuntimeAggOption, allDims: Dimension[]) => getFieldByName(allDims, runtimeAgg.dimensions[0])
const aggFirstInd2Field = (runtimeAgg: RuntimeAggOption, allDims: Dimension[]) => getFieldByName(allDims, runtimeAgg.indicators[0].dimName)
const stackAggFields = (pureColor = false) => [{
  name: 'yFieldObjs',
  valueFactory: ({ indicators }: RuntimeAggOption, allDims: Dimension[]) => {
    return indicators.map((ind, i) => ({
      valueField: getFieldByName(allDims, ind.dimName),
      color: pureColor
        ? PlThemeColors.pure[i % indicators.length]
        : PlThemeColors.gradient[i % indicators.length]
    }))
  }
}, {
  name: 'categoryFieldName',
  valueFactory: aggFirstDim2Field
}]
const barAggFields = [
  { name: 'categoryFieldName', valueFactory: aggFirstDim2Field },
  { name: 'valueFieldName', valueFactory: aggFirstInd2Field }
]
export const chartAggFieldMap: {
  [chartCode: string]: {
    name: string
    valueFactory
  }[]
} = {
  stack: stackAggFields(),
  area: stackAggFields(true),
  'bar-group': stackAggFields(),
  'widget-line': stackAggFields(true),
  bar: barAggFields,
  pie: barAggFields,
  pie2: barAggFields,
  'bar-horizontal': barAggFields,
  'simple-line': barAggFields,
  'bar-multiple': [
    { name: 'categoryFieldName', valueFactory: aggFirstDim2Field },
    { name: 'valueFieldNameOne', valueFactory: aggFirstInd2Field },
    { name: 'valueFieldNameTwo', valueFactory: (runtimeAgg: RuntimeAggOption, allDims: Dimension[]) => getFieldByName(allDims, runtimeAgg.indicators[1].dimName) },
  ]
}
function getFieldByName (dims: Dimension[], dimName: string): DataField {
  const { name, label } = dims.find(dim => dim.name === dimName)
  return { name, label }
}
export function isWidgetRuntimeAggActive (widgetName: string) {
  return Object
    .keys(chartAggFieldMap)
    .includes(widgetName)
}
